import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { RootState } from "app/store";
import { DialogType } from "app/types";
import { actions } from "app/configSlice";
import { useScale, usePlaySound } from "common/utils";
import { NewMarkSvg } from "features/home/assets";
import { useShouldShowTrialNotice } from "features/subscription/hooks";

export const NotificationBanner = ({ from }: { from: string }) => {
  const play = usePlaySound();
  const { scale } = useScale();
  const dispatch = useDispatch();
  const isTrial = useShouldShowTrialNotice();
  const notification = useSelector((state: RootState) => state.config.notification.kids);
  const maintenances = useSelector((state: RootState) => state.config.notification.maintenances);
  const config = useSelector((state: RootState) => state.config.userConfig);

  if (isTrial) return null;

  const NOTIFICATION_WIDTH = 700;
  const NOTIFICATION_HEIGHT = 100;

  const handleShowNotification = () => {
    play();
    dispatch(
      actions.updateDialog({
        type: DialogType.NOTIFICATION,
        value: true,
      }),
    );
  };

  const isMaintenance = maintenances.length > 0;
  const item = isMaintenance ? maintenances[0] : notification[0];
  const isNew = item ? dayjs().diff(item.published_at, "day") < 7 : false;
  const accentColor = isMaintenance ? "#FC6560" : "#4C9DF1";

  return notification.length !== 0 ? (
    <div
      className="flex-col-el items-center absolute cursor-pointer"
      style={{
        top: 11 * scale,
        width: NOTIFICATION_WIDTH * scale,
        height: NOTIFICATION_HEIGHT * scale,
      }}
    >
      <div
        className={`flex-row-el shrink-0 items-center justify-start origin-top overflow-hidden rounded-xl border-2 border-solid border-white gap-3 p-2 ${
          from === "home" ? "bg-white/60" : "bg-white/80"
        }`}
        style={{
          width: NOTIFICATION_WIDTH,
          height: NOTIFICATION_HEIGHT,
          transform: `scale(${scale}) translateZ(0)`,
          backfaceVisibility: "hidden",
          WebkitBackfaceVisibility: "hidden",
          boxShadow: "0px 1px 3px rgba(63, 74, 97, 0.3)",
        }}
        onClick={handleShowNotification}
      >
        <div
          className={`flex-col-center w-full h-full !absolute top-0 left-0 z-[-1] rounded-xl ${
            from === "home" && "backdrop-blur-[16px]"
          }`}
        />

        <div
          className="flex-col-el flex-center shrink-0 w-14 h-14 rounded-xl"
          style={{ backgroundColor: accentColor }}
        >
          <span className="material-symbols-outlined type-title text-white">
            notification_important
          </span>
        </div>

        <div className="flex-col-el items-start justify-between flex-1 min-w-0 h-14">
          <div className="flex-row-el items-center gap-2">
            <p className="type-text type-sm text-gray-100 !text-left leading-tight">
              {item?.[config.locale]?.date}
            </p>
            {isNew && (
              <span className="inline-block w-[58px] h-[32px] ml-[8px]">
                <NewMarkSvg />
              </span>
            )}
          </div>
          <p className="type-text type-body text-textcolor-black !text-left leading-tight w-full self-start text-body-ellipsis">
            {item?.[config.locale]?.title}
          </p>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
